import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'

type Refresh = () => void

interface SplitPassengerItemReservationParams {
  hashItemReserve: string
  refresh: Refresh
  notify: any
  setLoadingSplitItem: React.Dispatch<React.SetStateAction<boolean>>
  setConfirm: React.Dispatch<React.SetStateAction<boolean>> | undefined
  setOpen: React.Dispatch<React.SetStateAction<boolean>> | undefined,
  setForcedSplit: React.Dispatch<React.SetStateAction<boolean>> | undefined,
  ids_passenger: number[],
  setIsSeparatingPassengers: React.Dispatch<React.SetStateAction<boolean>>,
}

export const splitPassengerItemReservation = async ({
  hashItemReserve,
  refresh,
  notify,
  setLoadingSplitItem,
  setConfirm,
  setOpen,
  ids_passenger,
  setIsSeparatingPassengers
}: SplitPassengerItemReservationParams): Promise<void> => {
  try {
    setLoadingSplitItem(true)
    setOpen && setOpen(false)
    const response = await itemServices.split_passenger(hashItemReserve, ids_passenger)
    if (response >= 200 && response <= 204) {
      notify('ra.notification.splited_item_reserve_success', {
        type: 'success'
      })
      setConfirm && setConfirm(false)
      return
    }
    setConfirm && setConfirm(false)
    notify('ra.notification.splited_item_reserve_error', {
      type: 'error'
    })
  } catch (error) {
    notify('ra.notification.splited_item_reserve_error', {
      type: 'error'
    })
 
    setConfirm && setConfirm(false)
    setOpen && setOpen(false)
  } finally {
    customAwait([refresh, () => setLoadingSplitItem(false)])
    setIsSeparatingPassengers(false)
  }
}
